import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const AboutContainer = styled.div`
    max-width: 50rem;
    margin: 0 auto;
    padding: 1.25rem;
`;

export const About = styled.article`
    margin-bottom: 2.5rem;
    padding: 1.25rem;
    border-bottom: 1px solid #ccc;

    h2 {
        margin-top: 0;
    }
`;

export const Container = styled.div`
    width: 80%;
    overflow: hidden;
    margin: 5rem auto;

    ${device.md} {
        width: 60%;
    }
`;

export const Header = styled.div`
    color: ${colourScheme.fullWhite};
    padding: 1.25rem 0;
    text-align: center;
`;

export const AboutSection = styled.div`
    padding: 1.25rem;
    border-bottom: 1px solid ${colourScheme.fullWhite};

    &:last-child {
        border-bottom: none;
    }
`;

export const AboutTitle = styled.h2`
    color: ${colourScheme.success};
`;

export const AboutText = styled.p`
    color: ${colourScheme.fullWhite};
`;
